import React from "react";
import { Container, Image, Row, Col } from "react-bootstrap";
import { OUR_CUSTOMERS_TITLE } from "../Contexts/config";

export const CustomersSection = ({lang}) => {

    return (
        <Container style={{paddingTop: 120}} id="customers">
            <h1 className="text-center">{OUR_CUSTOMERS_TITLE[lang]}</h1>
            <Row>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"https://olympic.uz/ru/"}>
                        <Image fluid src={"assets/noc.png"} alt="" />
                    </a>
                </Col>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"https://ufa.uz/"}>
                        <Image fluid src={"assets/ufa.png"} alt="" />
                    </a>
                </Col>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"https://pfl.uz"}>
                        <Image fluid src={"assets/uzpfl.png"} alt="" />
                    </a>
                </Col>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"https://www.ice-hockey.uz"}>
                        <Image fluid src={"assets/uihf.png"} alt="" />
                    </a>
                </Col>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"https://uca.uz"}>
                        <Image fluid src={"assets/cybersport.png"} alt="" />
                    </a>
                </Col>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"https://tennis.uz/en"}>
                        <Image fluid src={"assets/utf.png"} alt="" />
                    </a>
                </Col>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"http://www.pakhtakor.uz/en"}>
                        <Image fluid src={"assets/pakhtakor-new.png"} alt="" />
                    </a>
                </Col>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"https://pfcsurkhon.uz"}>
                        <Image fluid src={"assets/surkhon.png"} alt="" />
                    </a>
                </Col>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"https://pfcnavbahor.uz/index.php/uz/"}>
                        <Image fluid src={"assets/navbakhor.png"} alt="" />
                    </a>
                </Col>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"http://lokomotiv.uz/?lang=ru"}>
                        <Image fluid src={"assets/lokomotiv.png"} alt="" />
                    </a>
                </Col>
                <Col lg={2} md={4} sm={6} className="p-4 d-flex justify-content-center align-items-center">
                    <a href={"https://hchumo.uz/"}>
                        <Image fluid src={"assets/humo.png"} alt="" />
                    </a>
                </Col>
            </Row>
        </Container>
    );
}